module.exports = __webpack_public_path__ + "img/dashboard.2284745f.png";